import { API_CLIENT_REPORT } from "../consts/apiRoutes.consts"
import SERVICE_CONSTS from "../consts/services.consts"
import { api } from "./base/api.service"

const { RESPONSE_BASIC_STRUCTURE, MESSAGES } = SERVICE_CONSTS

export const getClientSprintsByClientId = async (clientId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientSprintsByClientId/${clientId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientPeriodByClientIdAndPeriodType = async (
  clientId,
  periodType
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientPeriodByClientIdAndPeriodType/${clientId}/${periodType}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientSprintSummaryBySprintId = async (sprintId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientSprintSummaryBySprintId/${sprintId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientSprintPointProgressBySprintId = async (sprintId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientSprintPointProgressBySprintId/${sprintId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientSprintBudgetStateBySprintId = async (
  sprintId,
  config = {}
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientSprintBudgetStateBySprintId/${sprintId}`,
      null,
      {
        signal: config.signal || null,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./clientReport.service.types")["getClientSprintDetailedEstimationBySprintId"]} */
export const getClientSprintDetailedEstimationBySprintId = async (sprintId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientSprintDetailedEstimationBySprintId/${sprintId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const finishClientSprint = async (
  sprintId,
  clientId,
  teamMemberPoints,
  startDate,
  endDate,
  closeType,
  clientSprintCloseReasonId = null,
  closeReasonAdditionalText = null
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_CLIENT_REPORT}/finishClientSprint/${sprintId}`,
      {
        clientId,
        teamMemberPoints,
        startDate,
        endDate,
        closeType,
        clientSprintCloseReasonId,
        closeReasonAdditionalText,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const updateClientSprintTeamMemberPoints = async (
  sprintId,
  teamMemberPoints
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }
  let result
  try {
    result = await api.post(
      `${API_CLIENT_REPORT}/updateClientSprintTeamMemberPoints/${sprintId}`,
      { teamMemberPoints }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }
  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const approveClientSprint = async (
  sprintId,
  teamMemberPoints,
  startDate,
  endDate,
  approvalDate
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_CLIENT_REPORT}/approveClientSprint/${sprintId}`,
      { teamMemberPoints, startDate, endDate, approvalDate }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

/** @type {import("./clientReport.service.types")["getClientSprintLog"]} */
export const getClientSprintLog = async (clientId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientSprintLog/${clientId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getSprintClientEstimation = async (sprintId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }
  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getSprintClientEstimation/${sprintId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }
  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const editClientEstimation = async (
  sprintId,
  clientId,
  date,
  motive,
  estimationsByType
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_CLIENT_REPORT}/editClientEstimation`, {
      sprintId,
      clientId,
      date,
      motive,
      estimationsByType,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientPeriodConsumptionSummary = async (
  periodId,
  periodType
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientPeriodConsumptionSummary/${periodType}/${periodId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientPeriodAverageConsumption = async (clientId, maxDate) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientPeriodAverageConsumption/${clientId}`,
      { maxDate }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientPeriodConsumptionDistributionByArea = async (
  periodId,
  periodType
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientPeriodConsumptionDistributionByArea/${periodId}/${periodType}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientPeriodConsumptionDistributionByProject = async (
  periodId,
  periodType
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientPeriodConsumptionDistributionByProject/${periodId}/${periodType}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientPeriodBudgetStateByIdAndPeriodType = async (
  periodId,
  periodType,
  config = {}
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientPeriodBudgetStateByIdAndPeriodType/${periodId}/${periodType}`,
      null,
      {
        signal: config.signal || null,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientReportBurnchartDataByClientIdAndPeriod = async (
  clientId,
  periodId,
  periodType
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getBurnchartDataByWeeks/${clientId}/${periodType}/${periodId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getDownloadClientReportSprintSummary = async (sprintId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getDownloadClientReportSprintSummary/${sprintId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientMembersSummary = async ({
  sprintId,
  clientId,
  sprintsPeriod,
}) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_CLIENT_REPORT}/getClientMembersSummary`, {
      clientId,
      sprintId,
      sprintsPeriod,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getDownloadClientReportSprintTimeConsumption = async (
  sprintId
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getDownloadClientReportSprintTimeConsumption/${sprintId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientReportTimeConsumption = async (
  periodId,
  periodType = "SPRINT"
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_CLIENT_REPORT}/getClientReportTimeConsumption`,
      {
        periodId,
        periodType,
      }
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getCloseReasons = async ({ closeType }) => {
  if (!closeType) throw new Error("closeType is required")

  try {
    const url = `${API_CLIENT_REPORT}/getCloseReasons?closeType=${closeType}`

    const res = await api.get(url, {
      closeType,
    })
    if (!res.ok) {
      const errorText = await res.text()
      throw new Error(errorText || "Error fetching close reasons")
    }

    let data
    try {
      data = await res.json()
    } catch (e) {
      const text = await res.text()
      data = { result: text }
    }

    return data.result || data
  } catch (error) {
    console.error("Error fetching sprint close reasons:", error)
    throw error
  }
}

export const getTeamsHistory = async (clientId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(`${API_CLIENT_REPORT}/getTeamsHistory/${clientId}`)
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const encryptClientReportData = async (data) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_CLIENT_REPORT}/encryptClientReportData`, {
      data,
    })

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const decryptClientReportData = async (encryptedData) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_CLIENT_REPORT}/decryptClientReportData`, {
      data: encryptedData,
    })
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const getSprintReportDocuments = async (sprintId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getSprintReportDocuments/${sprintId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const createSprintReportDocument = async (formData) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_CLIENT_REPORT}/createSprintReportDocument`,
      formData
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const groupSprintsByBlock = async ({
  sprintsIds,
  clientId,
  reportNotes,
}) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_CLIENT_REPORT}/groupSprintsByBlock`, {
      sprintsIds,
      clientId,
      reportNotes,
    })

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const groupBlocksByCycle = async ({
  blocksIds,
  clientId,
  reportNotes,
}) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(`${API_CLIENT_REPORT}/groupBlocksByCycle`, {
      blocksIds,
      clientId,
      reportNotes,
    })

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const getSprintBlocksByClientId = async (clientId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getSprintBlocksByClientId/${clientId}`
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const getSprintCyclesByClientId = async (clientId) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getSprintCyclesByClientId/${clientId}`
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

/** @type {import("./clientReport.service.types")["getClientSprintDetailedEstimationByPeriod"]} */
export const getClientSprintDetailedEstimationByPeriod = async (
  periodId,
  periodType
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientSprintDetailedEstimationByPeriod/${periodType}/${periodId}`
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const getDownloadClientReportSprintSummaryNew = async (
  periodId,
  period,
  clientId
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getDownloadClientReportSprintSummary/${periodId}/${period}/${clientId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const getClientReportNotes = async (periodId, periodType) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientReportNotes/${periodId}/${periodType}`
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const getLastSprintIdByPeriod = async (periodId, periodType) => {
  const response = {
    ...RESPONSE_BASIC_STRUCTURE,
    result: null,
  }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getLastSprintIdByPeriod/${periodId}/${periodType}`
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

export const getBudgetProjectionEstimation = async (
  clientId,
  periodType,
  periodId
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result

  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getBudgetProjectionEstimation/${clientId}/${periodType}/${periodId}`
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()

  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}

/**
 * Obtiene datos adicionales para el PDF del reporte de cliente
 * @param {number} periodId - ID del período (sprintData.id)
 * @param {number} clientId - ID del cliente
 * @param {string} periodType - Tipo de período ("sprint" | "block" | "cycle")
 * @returns {Promise<{
 *   success: boolean,
 *   result: {
 *     semanasNominales: number | null,
 *     semanasOptimistas: number | null,
 *     semanasPesimistas: number | null,
 *     blockEndDate: string | null,
 *     holidays: string[],
 *     averagePointsPerBlock: number | null,
 *     estimatedEndDate: string | null
 *   } | null,
 *   message: string
 * }>}
 */
export const getClientReportPdfData = async (
  periodId,
  clientId,
  periodType
) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.get(
      `${API_CLIENT_REPORT}/getClientReportPdfData/${clientId}/${periodType.toUpperCase()}/${periodId}`
    )
    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS
  return response
}

export const createClientSprintMilestone = async ({
  clientSprintId,
  milestoneName,
  totalPoints,
  nextImportantDate,
  nextImportantDateName,
}) => {
  const response = { ...RESPONSE_BASIC_STRUCTURE, result: null }

  let result
  try {
    result = await api.post(
      `${API_CLIENT_REPORT}/createClientSprintMilestone`,
      {
        clientSprintId,
        milestoneName,
        totalPoints,
        nextImportantDate,
        nextImportantDateName,
      }
    )

    if (!result.ok) {
      const errorResult = await result.json()
      response.message = errorResult.details
      throw new Error()
    }
  } catch (error) {
    return response
  }

  const resultJson = await result.json()
  response.result = resultJson.result
  response.success = true
  response.message = MESSAGES.SUCCESS

  return response
}
